const WORDS = [
  "Gartenplanung",
  "Landschaftsbau",
  "Terrassen",
  "Pflasterung",
  "Bepflanzung",
  "Gartenpflege",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-[#17251C]/12 bg-[#DCCDB4] py-6">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
          {WORDS.map((w) => (
            <span key={w + dup} className="flex items-center">
              <span className="display-xl px-10 text-2xl text-[#2F3D2E] md:text-4xl">{w}</span>
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#B4623C]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
